import request from "@/utils/request";

// 查询钱包余额
export function getWallet(id) {
  return request({
    url: '/account/my-wallet/' + id,
    method: 'get',
  })
}
// 提现
export function withdraw(data) {
  return request({
    url: '/account/customer-draw-cash/addDrawCash',
    method: 'post',
    data
  })
}
// 提现记录
export function withdrawRecord(params) {
  return request({
    url: '/account/customer-draw-cash/page',
    method: 'get',
    params
  })
}
// 账户明细
export function getClientFundsDetail(params) {
  return request({
    url: '/account/customer-funds-detail/h5/page',
    method: 'get',
    params
  })
}